import { ArrowRight, CalendarDays, Clock, MapPin } from "lucide-react";

const MAPS_URL = "https://maps.app.goo.gl/1XX1VKnTPo1Yq1US6?g_st=ic";
const VENUE_IMG =
  "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=1200&q=80";

export default function EventDetails({ details }) {
  return (
    <section data-testid="wedding-event-details">
      <div className="gold-frame overflow-hidden bg-white">
        <div className="relative h-60 sm:h-72">
          <img
            src={VENUE_IMG}
            alt="სარიტუალო დარბაზი ლიდერი"
            className="h-full w-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/25 to-black/10" />
          <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center text-white">
            <p className="eyebrow !text-white/75">ცერემონია და ზეიმი</p>
            <h3
              data-testid="wedding-venue-title"
              className="mt-3 text-2xl font-medium leading-snug drop-shadow-md sm:text-3xl"
            >
              სარიტუალო დარბაზი
              <br />
              „ლიდერი“
            </h3>
          </div>
        </div>

        <div className="flex flex-col items-center gap-4 px-6 py-6">
          <div className="flex items-center justify-center gap-6 text-sm text-[#57534E]">
            <span className="flex items-center gap-2">
              <CalendarDays size={15} className="text-[#B8860B]" />
              {details.date}
            </span>
            <span data-testid="wedding-event-time" className="flex items-center gap-2">
              <Clock size={15} className="text-[#B8860B]" />
              18:00 სთ
            </span>
          </div>

          <a
            data-testid="wedding-location-maps-button"
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 border border-[#D9C9A3] bg-white px-8 py-3 text-xs font-semibold uppercase tracking-[0.22em] text-[#1C1917] shadow-sm transition-all hover:bg-[#FFF9EA] hover:shadow-md"
          >
            <MapPin size={14} className="text-[#B8860B]" />
            ლოკაცია
            <ArrowRight size={14} />
          </a>
        </div>
      </div>
    </section>
  );
}
